const envSettings = window as any;

export class ConfigurationVariables {
  static KONG_URL = envSettings.ENV.KONG_URL;
  static FORGE_IAM_CLIENT_ID = envSettings.ENV.FORGE_IAM_CLIENT_ID;
  static FORGE_IAM_SCOPE = envSettings.ENV.FORGE_IAM_SCOPE;
  static FORGE_IAM_AUTHORITY = envSettings.ENV.FORGE_IAM_AUTHORITY;
  static TenantMgmt_Endpoints = envSettings.ENV.TenantMgmt_Endpoints;
  static UserMgmt_Endpoints = envSettings.ENV.UserMgmt_Endpoints;
  static Api = envSettings.ENV.Api;
  static Version = envSettings.ENV.Version;
  static TenantController = envSettings.ENV.TenantController;
  static UserController = envSettings.ENV.UserController;
  static RouteLogo = envSettings.ENV.RouteLogo;
  static RouteDatacenters = envSettings.ENV.RouteDatacenters;
  static RouteCurrencies = envSettings.ENV.RouteCurrencies;
  static RouteTimezones = envSettings.ENV.RouteTimezones;
  static RouteApplications = envSettings.ENV.RouteApplications;
  static RouteTenants = envSettings.ENV.RouteTenants;
  static RouteUserPermissions = envSettings.ENV.RouteUserPermissions;
  static DebounceTime_InMilliSeconds =
    envSettings.ENV.DebounceTime_InMilliSeconds;
  static RouteForgeCustomerTenantDetails =
    envSettings.ENV.RouteForgeCustomerTenantDetails;
  static GeoMappingAddress = envSettings.ENV.GeoMappingAddress;
  static userVersion = envSettings.ENV.userVersion;
  static OrganisationController = envSettings.ENV.OrganisationController;
  static POLLING_INTERVAL = envSettings.ENV.POLLING_INTERVAL;
  static RouteIdentityProviders = envSettings.ENV.RouteIdentityProviders;
  static RouteCountryCode = envSettings.ENV.RouteCountryCode;
  static RouteOrganizationUser = envSettings.ENV.RouteOrganizationUser;
  static RouteMetaData = envSettings.ENV.RouteMetaData;
  static RouteSettings = envSettings.ENV.RouteSettings;
  static Tenant_Settings_Public_Key =
    envSettings.ENV.Tenant_Settings_Public_Key;
  static PROMPT_BEFORE_SESSION_IDLE_TIME_IN_MS =
    envSettings.ENV.PROMPT_BEFORE_SESSION_IDLE_TIME_IN_MS;
  static IDLE_SESSION_TIME_IN_MS = envSettings.ENV.IDLE_SESSION_TIME_IN_MS;
  static USERMANUAL_URL = envSettings.ENV.USERMANUAL_URL;
  static LAUNCHDARKLYCLIENTID = envSettings.ENV.LAUNCHDARKLYCLIENTID;
  static DOWNLOAD_HELP_GUIDE_PDF_URL = envSettings.ENV.DOWNLOAD_HELP_GUIDE_PDF_URL;
  static Tenant_Settings_Default_Country = envSettings.ENV.Tenant_Settings_Default_Country;
}